import { Box } from '@mui/material'
import React from 'react'
import Suisse from '../../../frontend-lib/typhograpy/Suisse'

export function WeKeepAnEyeCard({ icon, title }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: { xs: 'center', sm: 'flex-start' },
        width: '292px',
        mx: 4,
      }}
    >
      <Box sx={{ mb: 1, ml: 1 }}>{icon}</Box>
      <Suisse
        size={18}
        color="white"
        sx={{ textAlign: { xs: 'center', sm: 'start' } }}
      >
        {title}
      </Suisse>
    </Box>
  )
}
